{
  "journalAudit.action.dependency.answered": "Requested dependency answered"
}
